import { DashboardModule, Form } from '@domain-group/suit-theme'

import { useTeamForm } from '@hooks/useTeam'

interface TeamDetailsProps {
  teamFormPayload: ReturnType<typeof useTeamForm>,
}

const TeamDetails = (props: TeamDetailsProps) => {
  const {
    teamFormPayload: {
      entityState: {
        description,
        title,
      },
      errors,
      handlers,
    },
  } = props

  return (
    <DashboardModule title="Team Details">
      <Form padding="large">
        <Form.Field errorMessage={errors.title} label="* Title">
          <input
            name="title"
            value={title}
            type="text"
            {...handlers}
          />
        </Form.Field>

        <Form.Field errorMessage={errors.description} label="* Description" marginTop="large">
          {/*
           // @ts-expect-error TS2322 */}
          <textarea
            name="description"
            value={description}
            style={{ height: 120, resize: 'vertical' }}
            {...handlers}
          />
        </Form.Field>
      </Form>
    </DashboardModule>
  )
}

export default TeamDetails
